RivalIQ.module('payment', function (payment, App, Backbone, Marionette, $, _) {

    'use strict';

    // StripeCheckout from options for testing.
    function getStripeCheckout(options) {
        const StripeCheckout = _.get(options, 'StripeCheckout', window.StripeCheckout);
        return StripeCheckout;
    }

    // todo: reference this another way, or just use $
    const PlanSignup = Backbone.Model.extend({
        url: function () {
            return '/charge';
        }
    });

    // todo: reference this another way, or just use $
    const UpdatePlan = Backbone.Model.extend({
        url: function () {
            return '/updatePlan/false';
        }
    });

    function errorHandler(model, response) {
        $('#subscriptionLoadingModal .x-message').html(`Error: ${response.errorMessage || 'Network Error'}`);
        $('#subscriptionLoadingModal .x-button-container').show();
        $('#subscriptionLoadingModal .x-contact-us').on('click', function () {
            window.Intercom('show');
        });
    }

    function completePaymentAction(message, response, options) {
        const dismissModalAndNavigate = function () {
            $('#subscriptionLoadingModal').modal('hide');
            if (options.successCallback) {
                options.successCallback(response, options);
            } else if (window.location.pathname === '/suspended') {
                // update card appears on the suspended and the subscription page
                // from the subscription page, we want to simply reload
                // from the suspended page, if the update is successful, we want to redirect to the default overview
                window.location.href = '/overview';
            } else {
                window.location.reload();
            }
        };

        if (options.successModalTimeout === 0) {
            dismissModalAndNavigate();
        } else {
            $('#subscriptionLoadingModal .x-message').html(message);
            setTimeout(dismissModalAndNavigate, options.successModalTimeout || 2500);
        }
    }

    // exposed for testing
    payment._completePaymentAction = completePaymentAction;

    function postStripe(options, res) {

        const plan = options.plan;
        const signupPlan = new PlanSignup();

        $('.modal').modal('hide');
        $('#subscriptionLoadingModal .x-message').html('Completing your transaction...');
        $('#subscriptionLoadingModal .x-button-container').hide();
        $('#subscriptionLoadingModal').modal('show');

        signupPlan.save({
            token: res,
            plan: plan.stripe_id
        }, {
            success: function (response) {

                App.execute('tracking:push:auth', App.tracking.metric.Upgraded, {
                    'plan level': plan.stripe_id
                });
                if (window.gaSubscribedConversionSendTo) {
                    RivalIQ.execute('tracking:push:gtag', 'conversion', {
                        send_to: window.gaSubscribedConversionSendTo,
                        transaction_id: RivalIQ.state.account.id
                    });
                }

                options.successCallback = function (response, options) {
                    const extendedOptions = _.extend({
                        csm: response.get('csm'),
                        isNewPurchaser: true,
                        getsPersonalizedOnboarding: RivalIQ.state.account.get('groupId') === 80
                    }, options);
                    RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.OnboardingModal(extendedOptions));
                };
                completePaymentAction('Success! Emailing receipt.', response, options);
            },
            error: errorHandler
        });
    }

    function postUpdateCard(options, res) {

        $('.modal').modal('hide');
        $('#subscriptionLoadingModal .x-message').html('Updating your card...');
        $('#subscriptionLoadingModal .x-button-container').hide();
        $('#subscriptionLoadingModal').modal('show');

        const api = function () {
            return $.post('/updateCard', {
                token: res
            });
        };

        const condition = function (response) {
            if (response.status === 'complete') {
                if (response.success) {
                    completePaymentAction('Card updated.  Reloading...', new Backbone.Model({
                        token: res
                    }), options);
                } else {
                    errorHandler(null, response);
                }

                return true;
            }
        };

        const pollingOptions = {
            pollingDelay: 5000,
            pollingMaxAttempts: -1,
            retry: true,
            skipFailFast: true
        };

        RivalIQ.utils.polling.pollUntilCondition(api, condition, pollingOptions)
            .fail(errorHandler);
    }

    function updatePlan(options) {
        const plan = options.plan;
        const isUpgrade = (parseInt(RivalIQ.settings.plan.price) <= parseInt(plan.price));

        $('#subscriptionLoadingModal .x-message').html('Completing your plan change...');
        $('#subscriptionLoadingModal .x-button-container').hide();
        $('#subscriptionLoadingModal').modal('show');

        const updatePlanInstance = new UpdatePlan();
        updatePlanInstance.save({
            plan: plan.stripe_id,
            upgrade: isUpgrade
        }, {
            success: function (response) {

                App.execute('tracking:push:auth', App.tracking.metric.V3UpdatePlan, {
                    'plan level': plan.stripe_id
                });

                const eventToLog = (isUpgrade ? App.tracking.metric.Upgraded : App.tracking.metric.Downgraded);
                App.execute('tracking:push:auth', eventToLog, {
                    'plan level': plan.stripe_id
                });

                completePaymentAction('Your plan change was successful.  Reloading...', response, options);
            },
            error: errorHandler
        });
    }

    function showStripeCheckoutForPlan(options) {

        const plan = options.plan;
        const updateCard = options.updateCard;

        const coupon = RivalIQ.state.account.get('currentStripeCoupon');

        const shouldApplyCoupon = payment.shouldApplyCoupon(coupon, plan);
        const price = payment.calculatePrice(coupon, plan);

        const panelLabel = (updateCard ? 'Update Card' : 'Complete Subscription');
        const planName = (plan.annual ? `${plan.name} Annual` : `${plan.name} Monthly`);
        const name = (updateCard ? 'Update Credit Card' : planName);
        const description = payment.calculateDescription(price, updateCard, shouldApplyCoupon, plan);

        const token = _.bind((updateCard ? postUpdateCard : postStripe), null, options);

        const stripeOptions = {
            key: payment.stripePublishableKey, // NOTE: expecting this to be set in Jade
            zipCode: true,
            name: name,
            email: App.state.user.get('email'),
            description: description,
            panelLabel: panelLabel,
            token: token,
            allowRememberMe: false,
            image: './images/bellcurve_circle.png'
        };

        getStripeCheckout(options).open(stripeOptions);
    }

    function showLoadingModal() {
        const view = new Marionette.ItemView({
            template: '#paymentLoadingTemplate',
            className: 'modal fade'
        });
        RivalIQ.execute('show:modal', view);
        view.$el.modal();
    }

    payment.start = function (options) {

        if (_.isUndefined(getStripeCheckout(options))) {
            return showLoadingModal();
        }

        const opts = _.defaults(options || {}, {
            reloadOnSuccess: true
        });
        showStripeCheckoutForPlan(opts);
    };

    payment.planChange = function (options) {
        if (App.settings.trial === true) {
            payment.start(options);
        } else {
            const opts = _.defaults(options || {}, {
                reloadOnSuccess: true
            });
            updatePlan(opts);
        }
    };

    // exposed for testing
    payment.shouldApplyCoupon = function (coupon, plan) {

        let result = false;

        if (coupon.annualOnly && plan.annual && coupon.discount) {
            result = true;
        } else if (coupon.monthlyOnly && !plan.annual && coupon.discount) {
            result = true;
        } else if (coupon.validSinglePlan && plan.stripe_id === coupon.validSinglePlan) {
            result = true;
        } else if (coupon.validSinglePlan && plan.stripe_id !== coupon.validSinglePlan) {
            result = false;
        } else if (!coupon.annualOnly && !coupon.monthlyOnly && !coupon.validSinglePlan && coupon.discount) {
            result = true;
        }
        return result;

    };

    // exposed for testing
    payment.calculatePrice = function (coupon, plan) {

        let price = plan.price;
        const shouldApplyCoupon = payment.shouldApplyCoupon(coupon, plan);

        if (shouldApplyCoupon) {
            price *= (1 - coupon.discount);
        }

        if (plan.annual) {
            price = price * 12;
        }

        price = (Number(price)).toLocaleString('en-us', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        return price;
    };

    // exposed for testing
    payment.calculateDescription = function (price, updateCard, shouldApplyCoupon, plan) {

        const description = (updateCard ? '' : `US${price + (plan.annual ? '/yr' : '/mo')} + applicable tax`);

        return description;
    };

    App.commands.setHandler('payment:start', payment.start);
    App.commands.setHandler('payment:planChange', payment.planChange);

});
